<template>
  <div>
    <!-- 搜索表单区域 -->
    <!-- <el-form :model="query" inline size="mini" label-position="left" label-width="40px">
      <el-form-item label="类型">
        <el-select v-model="query.type" placeholder="请选择资费类型">
          <el-option label="押金" value="1"></el-option>
          <el-option label="余额" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="请选择资费状态">
          <el-option label="未开启" value="0"></el-option>
          <el-option label="已开启" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="warning" size="mini" @click="reset">重置</el-button>
      <el-button type="success" size="mini" @click="seach">搜索</el-button>
      <el-button type="primary" size="mini" icon="el-icon-folder-add" class="addCostBtn" @click="addCostData">新增资费</el-button>
    </el-form> -->
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="costList"  style="width: 100%" height="650px" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="uuid" label="编号"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="amount" label="支付金额(元)"></el-table-column>
        <el-table-column prop="gainAmount" label="到账金额"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column label="类型" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">押金</span>
            <span v-else-if="scope.row.type === 2">余额</span>
            <span v-else-if="scope.row.type === 21">金</span>
            <span v-else-if="scope.row.type === 22">银</span>
            <span v-else-if="scope.row.type === 23">铜</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status === 1">正常</el-tag>
            <el-tag type="danger" v-else>关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sequence" label="排序" width="80"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="warning" icon="el-icon-edit" size="small" @click="editCostData(scope.row)">调整</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="curPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 新增资费对话框 -->
    <el-dialog title="新增资费" :visible.sync="addCostDialogVisible" width="40%">
      <!-- 新增资费表单区域 -->
      <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-position="left" label-width="120px">
        <el-form-item label="资费名称" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入资费名称"></el-input>
        </el-form-item>
        <el-form-item label="资费描述" prop="description">
          <el-input v-model="addForm.description" placeholder="请输入资费描述"></el-input>
        </el-form-item>
        <el-form-item label="支付金额" prop="amount">
          <el-input v-model="addForm.amount" placeholder="请输入支付金额"></el-input>
        </el-form-item>
        <el-form-item label="到账金额" prop="amount">
          <el-input v-model="addForm.gainAmount" placeholder="请输入实际到账金额"></el-input>
        </el-form-item>
        <el-form-item label="资费排序" prop="sequence">
          <el-input v-model="addForm.sequence" placeholder="请输入0-99"></el-input>
        </el-form-item>
        <el-form-item label="资费类型" prop="type">
          <el-select v-model="addForm.type" placeholder="请选择资费类型">
            <el-option label="押金" value="1"></el-option>
            <el-option label="余额" value="2"></el-option>
            <el-option label="金" value="21"></el-option>
            <el-option label="银" value="22"></el-option>
            <el-option label="铜" value="23"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资费状态" prop="status">
          <el-select v-model="addForm.status" placeholder="请选择资费状态">
            <el-option label="关闭" value="0"></el-option>
            <el-option label="正常" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCostDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCostSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改资费表单区域 -->
    <el-dialog title="修改资费信息" :visible.sync="editCostDialogVisible" width="40%">
      <!-- 修改资费表单区域 -->
      <el-form ref="editFormRef" :model="editForm" :rules="editFormRules" label-position="left" label-width="120px">
        <el-form-item label="资费编号" prop="uuid">
          <el-input v-model="editForm.uuid" disabled></el-input>
        </el-form-item>
        <el-form-item label="资费名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入资费名称"></el-input>
        </el-form-item>
        <el-form-item label="资费描述" prop="description">
          <el-input v-model="editForm.description" placeholder="请输入资费描述"></el-input>
        </el-form-item>
        <el-form-item label="支付金额" prop="amount">
          <el-input v-model="editForm.amount" placeholder="请输入支付金额"></el-input>
        </el-form-item>
        <el-form-item label="到账金额" prop="gainAmount">
          <el-input v-model="editForm.gainAmount" placeholder="请输入到账金额"></el-input>
        </el-form-item>
        <el-form-item label="资费排序" prop="sequence">
          <el-input v-model="editForm.sequence" placeholder="请输入0-99"></el-input>
        </el-form-item>
        <el-form-item label="资费类型" prop="type">
          <el-select v-model="editForm.type" disabled>
            <el-option label="押金" value="1"></el-option>
            <el-option label="余额" value="2"></el-option>
            <el-option label="金" value="21"></el-option>
            <el-option label="银" value="22"></el-option>
            <el-option label="铜" value="23"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资费状态" prop="status">
          <el-select v-model="editForm.status" placeholder="请选择资费状态">
            <el-option label="关闭" value="0"></el-option>
            <el-option label="正常" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editCostDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editCostSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { costList, add, edit } from '@/API/cost'
export default {
  name: 'cost',
  data() {
    return {
      // 资费数据请求参数
      query: {
        curPage: 1,
        pageSize: 10,
        type: '',
        status: ''
      },
      // 资费数据列表
      costList: [],
      // 数据总条数
      total: 0,
      //   新增资费对话框是否显示
      addCostDialogVisible: false,
      //   新增资费表单数据
      addForm: {
        name: '',
        description: '',
        amount: '',
        gainAmount: '',
        type: '',
        status: '',
        sequence: ''
      },
      //   新增资费表单验证规则
      addFormRules: {
        name: [{ required: true, message: '请输入资费名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入资费描述', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入支付金额', trigger: 'blur' }],
        gainAmount: [{ required: true, message: '请输入到账金额', trigger: 'blur' }],
        sequence: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        type: [{ required: true, message: '请选择资费类型', trigger: 'change' }],
        status: [{ required: true, message: '请选择资费状态', trigger: 'change' }]
      },
      //   修改资费对话框是否显示
      editCostDialogVisible: false,
      //   修改资费表单数据
      editForm: {
        uuid: '',
        name: '',
        description: '',
        amount: '',
        gainAmount: '',
        type: '',
        status: '',
        sequence: ''
      },
      editFormRules: {
        uuid: [{ required: true, message: '请输入资费标识', trigger: 'blur' }],
        name: [{ required: true, message: '请输入资费名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入资费描述', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入资费金额', trigger: 'blur' }],
        gainAmount: [{ required: true, message: '请输入到账金额', trigger: 'blur' }],
        sequence: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        type: [{ required: true, message: '请选择资费类型', trigger: 'change' }],
        status: [{ required: true, message: '请选择资费状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getCostList()
  },
  methods: {
    async getCostList() {
      const { data: res } = await costList(this.query)
      if (res.code !== 200) return this.$message.error('获取资费数据列表失败')
      this.costList = res.data.entities
      this.total = res.data.totalSize
    },
    seach() {
      if (this.query.type === '' && this.query.status === '') return
      this.query.curPage = 1
      this.getCostList()
    },
    reset() {
      this.query.type = ''
      this.query.status = ''
      this.getCostList()
    },
    // 新增资费
    addCostData() {
      this.addCostDialogVisible = true
    },
    // 新增资费提交
    addCostSubmit() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await add(this.addForm)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.addCostDialogVisible = false
      })
    },
    // 修改资费
    editCostData(costInfo) {
      this.editForm.uuid = costInfo.uuid
      this.editForm.name = costInfo.name
      this.editForm.description = costInfo.description
      this.editForm.amount = costInfo.amount
      this.editForm.gainAmount = costInfo.gainAmount
      this.editForm.type = costInfo.type + ''
      this.editForm.status = costInfo.status + ''
      this.editForm.sequence = costInfo.sequence
      this.editCostDialogVisible = true
    },
    // 修改资费提交
    async editCostSubmit() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await edit(this.editForm)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.getCostList()
        this.editCostDialogVisible = false
      })
    },
    // 监听pageSize变化
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getCostList()
    },
    // 监听curPage变化
    curPageChange(newPage) {
      this.query.curPage = newPage
      this.getCostList()
    }
  }
}
</script>

<style lang="less" scoped>
.el-form-item {
  margin-right: 50px !important;
}
.el-pagination {
  margin-top: 30px;
}
.addCostBtn {
  float: right;
  margin-right: 100px;
}
</style>
